import style from './Light-Loading-Page.module.scss'
import dark from './Dark-Loading-Page.module.css'
import redLogo from '../../../../assets/imgs/logo/el_gran_kush/lg_blck_png.png'

const LoadingPage = (props) => {
    let logo =  redLogo
    return (
        <div className={style.wrapper} style={props.style}>

                <div className={style.logoWrapper}>
                <div className={style.logo}></div>
                </div>
                
           {<p className={style.text}>Loading...</p>}
        </div>
    )
}
export default LoadingPage